export default function consoleLog(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args)
  }
}
